import React, { Component, createRef } from 'react';
import './style.css'
import { Button, FormGroup, Label, Input,
    TabContent, TabPane, Nav, NavItem, NavLink, Card, 
    CardTitle, Alert, CardFooter } from 'reactstrap';
import classnames from 'classnames'
import Axios from 'axios';
import Swal from 'sweetalert2'
import { DB_URL} from './../../helpers/url'
import { connect } from 'react-redux';
import {Redirect} from 'react-router-dom'
import {LoginAction } from './../../redux/actions'

class Login extends Component {
    state = { 
        email: createRef(),
        password: createRef(),
        activeTab: '1',
        regEmail: createRef(),
        regUsername: createRef(),
        regPass: createRef(),
        regConfirmPass: createRef(),
        alertReg: false,
        alertLogin: false,
        alertPass: false,
        alertUsername: false,
        alertPassStrength: false,
        regForm: {
            username:'',
            password:'',
            email:''
        }
    }

    toggle = (tab) => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    focusLogin=()=>{
        this.state.email.current.focus()
    }

    focusSignup=()=>{
        this.state.regUsername.current.focus()
    }

    onDismiss = () => {
        // this.props.ClearError()
        this.setState({alertLogin:false})
    }

    onDismissUser = () => {
        this.setState({alertUsername:false})
    }

    onDismissStrength = () => {
        this.setState({alertPassStrength:false})
    }

    onDismissLength = () => {
        this.setState({alertPassLength:false})
    }

    onDismissReg = (x)=>{
        if(x==='pass'){
            this.setState({alertPass:false})
        } else{
            this.setState({alertReg:false})
        }
    }

    onLoginClick=()=>{
        const {email,password} = this.state
        let emailLogin = email.current.value
        let passwordLogin = password.current.value
        if(emailLogin === '' || passwordLogin === ''){
            this.setState({alertLogin:true})
        } else{
            console.log(emailLogin)
            let data={
                email:emailLogin,
                password:passwordLogin
            }
            console.log(data)
            this.props.LoginAction(data)
        }
    }

    onRegisterClick=()=>{
        this.onDismiss()
        this.onDismissUser()
        this.onDismissReg('pass')
        this.onDismissReg()
        this.onDismissStrength()
        const {regEmail, regUsername, regPass, regConfirmPass} = this.state
        var regE = regEmail.current.value
        var regU = regUsername.current.value
        var regP = regPass.current.value
        var regConfP = regConfirmPass.current.value
        if(regU === '' || regP === '' || regConfP === ''){
            this.setState({alertReg:true})
        } else{
            // var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})")
            var strongRegex = new RegExp("^(?=.*[a-z]||[A-Z])(?=.*[0-9])(?=.{6,})")
            // var strongRegex = new RegExp("^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$")
            var checkPassword = regP.match(strongRegex)
            console.log(checkPassword)
            if(checkPassword){
                if(regP === regConfP){
                    let obj = {
                        username: regU,
                        email: regE,
                        password: regP
                    }
                    console.log(obj)
                    this.setState({regForm: obj})
                    Axios.post(`${DB_URL}/auth/register`,this.state.regForm)
                    .then(()=>{
                        this.setState({regStatus:true})
                        Swal.fire(
                        'Successfuly Sign Up!',
                        'Please open your email to verify user account',
                        'success'
                        )
                        regUsername.current.value = ''
                        regPass.current.value = ''
                        regConfirmPass.current.value = ''
                        this.toggle('1')
                        this.focusLogin()
                    }).catch((err)=>console.log(err))
                } else{
                    this.setState({alertPass:true})
                }
            }else{
                this.setState({alertPassStrength:true})
            }
        }
    }
    
    render() { 
        if(this.props.Auth.isLogin){
            return <Redirect exact to='/'/>
        } else{
            return ( 
                <div className='row m-0 p-0 bg-color-login'>
                    <div className='col-md-7 bg-login'></div>
                    <div className='col-md-5 login-form d-flex align-items-center justify-content-center'>
                        <div className='col-md-10'>
                            <Nav tabs>
                                <NavItem className='nav-cust-login'>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '1' })}
                                        onClick={() => { this.toggle('1'); }}
                                    >
                                        {
                                            this.state.activeTab === '1'?
                                            <span style={{color:'black'}} className='tabs-login'>Login</span>
                                            :
                                            <span style={{color:'white'}} className='tabs-login'>Login</span>
                                        }
                                    </NavLink>
                                </NavItem>
                                <NavItem className='nav-cust-login'>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '2' })}
                                        onClick={() => { this.toggle('2'); }}
                                    >
                                        {
                                            this.state.activeTab === '2'?
                                            <span style={{color:'black'}} className='tabs-login'>Sign Up</span>
                                            :
                                            <span style={{color:'white'}} className='tabs-login shadow-login'>Sign Up</span>
                                        }
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="1">
                                    <Card body>
                                        <CardTitle className='h3 my-3 text-left txt-grey'>Let's login <br/>to access dashboard</CardTitle>
                                        <FormGroup className='text-left txt-grey'>
                                            <Label>Email</Label>
                                            <Input type="email" name="email" id="exampleEmail" innerRef={this.state.email} required/>
                                        </FormGroup>
                                        <FormGroup className='text-left txt-grey'>
                                            <Label for="examplePassword">Password</Label>
                                            <Input type="password" name="password" id="examplePassword" innerRef={this.state.password} required/>
                                        </FormGroup>
                                        <div className='mt-3'>
                                            <Alert color="danger" isOpen={this.state.alertLogin} toggle={this.onDismiss}>
                                                Invalid username or password
                                            </Alert>
                                            <Alert color="danger" isOpen={this.state.alertLogin} toggle={this.onDismiss}>
                                                Data cannot be empty
                                            </Alert>
                                        </div>
                                        <Button color="primary" onClick={this.onLoginClick}>Login</Button>
                                        <CardFooter className='mt-3'>
                                            Don't have account? Create a new one &nbsp;
                                            <span className='tabs-login' style={{color:'blue'}} onClick={()=>this.toggle('2')}>here</span>
                                        </CardFooter>
                                    </Card> 
                                </TabPane>
                                <TabPane tabId="2">
                                    <Card body>
                                        <CardTitle className='h3 my-3 text-left txt-grey'>Join with us to see the future</CardTitle>
                                        <FormGroup className='text-left txt-grey'>
                                            <Label>Email</Label>
                                            <Input type="email" name="email" innerRef={this.state.regEmail}/>
                                        </FormGroup>
                                        <FormGroup className='text-left txt-grey'>
                                            <Label>Username</Label>
                                            <Input type="text" name="username" innerRef={this.state.regUsername}/>
                                        </FormGroup>
                                        <FormGroup className='text-left txt-grey'>
                                            <Label for="examplePassword">Password</Label>
                                            <Input type="password" name="password" innerRef={this.state.regPass}/>
                                        </FormGroup>
                                        <FormGroup className='text-left txt-grey'>
                                            <Label for="examplePassword">Confirm Password</Label>
                                            <Input type="password" name="password" innerRef={this.state.regConfirmPass}/>
                                        </FormGroup>
                                        <div className='mt-3'>
                                            <Alert color="danger" isOpen={this.state.alertReg} toggle={this.onDismissReg}>
                                                Please fill all the field
                                            </Alert>
                                            <Alert color="danger" isOpen={this.state.alertPass} toggle={()=>this.onDismissReg('pass')}>
                                                Password confirmation did not match
                                            </Alert>
                                            <Alert color="danger" isOpen={this.state.alertUsername} toggle={this.onDismissUser}>
                                                Username or Email has been used by someone
                                            </Alert>
                                            <Alert color="danger" isOpen={this.state.alertPassStrength} toggle={this.onDismissStrength}>
                                                Password length minimum should be 6 character and contain letter and number
                                            </Alert>
                                        </div>
                                        <Button color="primary" onClick={this.onRegisterClick}>Register</Button>
                                    </Card> 
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const reduxProps=(state)=>{
    return{
        Auth:state.Auth
    }
}
 
export default connect(reduxProps,{LoginAction})(Login);